<template>
  <div class="by_law">
      <div class="by_law-list">
        <LawNormFormByLawsItem 
          :item="item"
          v-for="(item, index) in byLaws"
          :key="index"
          @remove="removeByLaw"
          @clear="clear"
          @change="changeByLaw"
          :by-laws="selectByLaws"
        />
      </div>
    </div>
</template>
<script>
import LawNormFormByLawsItem from '@/components/law/LawNormFormByLawsItem.vue'

export default {
  name: 'LawNormFormArticle',
  components: {
    LawNormFormByLawsItem 
  },
  props: {
    byLaws: {
      type: Array,
      required: true
    },
    selectByLaws: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      byLawSelectedData: '',
      isEditShow: []
    }
  },
  mounted() {
    this.byLawSelectedData = this.selectByLaw
    this.selectedExistingArticle = true
    this.$forceUpdate()
  },
  methods: {
    removeByLaw(id) {
      this.$emit('remove', id)
    },

    changeByLaw(byLaw) {
      this.$emit('change', byLaw)
    },
    clear() {
      this.byLawSelectedData = ''
      this.$emit('clear')
    }
  }
}
</script>
<style lang="scss">
  .by_law {
  
    label {
      
    }
 
    &-list {
      width: 100%;

      .v-input--radio-group__input {
        flex-direction: column;
      }
    }

    &-item {
      display: flex;
      padding-left: 200px;
      padding-bottom: 20px;
      
      .v-label {
        padding: 0 !important;
      }

      &-pencil {
        cursor: pointer;
        display: flex;
        align-items: center;
      }

      &-remove {
        margin-left: 10px;
        cursor: pointer;
        display: flex;
        align-items: center;
      }
    }
  }
</style>